// Per-page SEO meta titles & descriptions for İONA Güzellik Merkezi
// Keywords targeted: İONA, İONA Güzellik, İONA Güzellik Merkezi, İONA Ümraniye,
// Ümraniye Güzellik Merkezi, Ümraniye Lazer Epilasyon, Ümraniye Cilt Bakımı,
// Saten Yüz Germe Ümraniye, Bölgesel İncelme Ümraniye.

export const SITE_SEO = {
  home: {
    title:
      "İONA Güzellik Merkezi | Ümraniye Lazer Epilasyon ve Cilt Bakımı",
    description:
      "İONA, Ümraniye'de lazer epilasyon, cilt bakımı, saten yüz germe, bölgesel incelme ve güzellik uygulamaları sunan profesyonel güzellik merkezidir.",
  },
  blogList: {
    title: "Blog | İONA Güzellik Merkezi · Ümraniye",
    description:
      "İONA blog: lazer epilasyon, cilt bakımı, saten yüz germe ve bölgesel incelme hakkında uzman içerikler. İONA Güzellik Merkezi · Ümraniye.",
  },
};

// Slug-specific SEO for service detail pages
export const SERVICE_SEO = {
  "lazer-epilasyon": {
    title:
      "Ümraniye Lazer Epilasyon · İONA Güzellik Merkezi · Buz Lazer & Alexandrite",
    description:
      "İONA Ümraniye Güzellik Merkezi'nde lazer epilasyon: Hibrit Alexandrite, Buz Lazer ve Diode teknolojileriyle kişiye özel, konforlu ve etkili uygulama. Ücretsiz deneme seansı için iletişime geçin.",
  },
  "bolgesel-incelme": {
    title: "Bölgesel İncelme · Ümraniye · İONA Güzellik Merkezi",
    description:
      "İONA Güzellik Merkezi Ümraniye'de bölgesel incelme: G5, EMS, Lenf Drenaj, Bubbles ve şekillendirme uygulamalarıyla bölgesel sıkılaşma ve toparlanma desteği.",
  },
  "saten-vucut-germe": {
    title: "Saten Vücut Germe · Ümraniye · İONA Güzellik Merkezi",
    description:
      "İONA Ümraniye'de saten vücut germe: radyo frekans ve ısı teknolojisiyle karın, basen, kol ve bacak bölgesinde ameliyatsız sıkılaştırma desteği.",
  },
  "saten-yuz-germe": {
    title: "Saten Yüz Germe · Ümraniye · İONA Güzellik Merkezi",
    description:
      "İONA Ümraniye Güzellik Merkezi'nde saten yüz germe: radyo frekans ile ameliyatsız yüz sıkılaştırma, gıdı toparlama ve cilt yenileme uygulamaları.",
  },
  hydrafacial: {
    title: "Hydrafacial Cilt Bakımı · Ümraniye · İONA Güzellik Merkezi",
    description:
      "İONA Ümraniye Güzellik Merkezi'nde Hydrafacial cilt bakımı: cildi derinlemesine arındırır, nemlendirir ve parlak bir görünüm kazandırır.",
  },
  "profesyonel-cilt-bakimi": {
    title: "Ümraniye Cilt Bakımı · Profesyonel · İONA Güzellik Merkezi",
    description:
      "İONA Güzellik Merkezi Ümraniye'de profesyonel cilt bakımı: cilt tipinize göre kişiye özel temizlik, arındırma ve nemlendirme protokolü.",
  },
  "kore-cilt-bakimi": {
    title: "Kore Cilt Bakımı · Ümraniye · İONA Güzellik Merkezi",
    description:
      "İONA Ümraniye'de Kore cilt bakımı: leke görünümü, matlık ve cilt tonu eşitsizliği için aydınlatıcı bakım protokolü.",
  },
  "3d-cilt-analizi": {
    title: "3D Cilt Analizi · Ümraniye · İONA Güzellik Merkezi",
    description:
      "İONA Ümraniye Güzellik Merkezi'nde 3D cilt analizi ile cildinizin nem, leke, gözenek ve ince çizgi yapısı değerlendirilir; kişiye özel bakım planı oluşturulur.",
  },
  "g5-masaji": {
    title: "G5 Masajı · Ümraniye · İONA Güzellik Merkezi",
    description:
      "İONA Ümraniye'de G5 masajı: bölgesel sıkılaşma, selülit görünümü ve dolaşım desteği için profesyonel uygulama.",
  },
  ems: {
    title: "EMS · Vücut Şekillendirme · Ümraniye · İONA Güzellik Merkezi",
    description:
      "İONA Ümraniye Güzellik Merkezi'nde EMS uygulaması: elektromanyetik kas uyarımı ile kas aktivasyonu ve vücut şekillendirme desteği.",
  },
  "lenf-drenaj": {
    title: "Lenf Drenaj · Ümraniye · İONA Güzellik Merkezi",
    description:
      "İONA Ümraniye'de lenf drenaj uygulaması: ödem görünümünü azaltmaya ve vücudu rahatlatmaya yardımcı destekleyici bakım protokolü.",
  },
  microblading: {
    title: "Microblading · Kaş Tasarımı · Ümraniye · İONA Güzellik Merkezi",
    description:
      "İONA Ümraniye Güzellik Merkezi'nde microblading: kişiye özel, doğal görünümlü, dolgun ve simetrik kaş tasarımı uygulaması.",
  },
  "kas-laminasyon": {
    title: "Kaş Laminasyon · Ümraniye · İONA Güzellik Merkezi",
    description:
      "İONA Ümraniye'de kaş laminasyon: kaşları sabitleyerek daha dolgun, düzenli ve şekilli bir görünüm kazandıran bakım uygulaması.",
  },
  "kirpik-lifting": {
    title: "Kirpik Lifting · Ümraniye · İONA Güzellik Merkezi",
    description:
      "İONA Ümraniye Güzellik Merkezi'nde kirpik lifting: doğal kirpikleri daha kıvrık, uzun ve belirgin gösteren bakım uygulaması.",
  },
  "dudak-renklendirme": {
    title: "Dudak Renklendirme · Ümraniye · İONA Güzellik Merkezi",
    description:
      "İONA Ümraniye'de yarı kalıcı dudak renklendirme: dudaklara daha canlı, dengeli ve doğal bir görünüm kazandıran uygulama.",
  },
  "ignesiz-mezoterapi": {
    title: "İğnesiz Mezoterapi · Ümraniye · İONA Güzellik Merkezi",
    description:
      "İONA Ümraniye Güzellik Merkezi'nde iğnesiz mezoterapi: cilde nem, parlaklık ve canlılık kazandıran konforlu bakım uygulaması.",
  },
  "cilt-aydinlatma": {
    title: "Cilt Aydınlatma Bakımı · Ümraniye · İONA Güzellik Merkezi",
    description:
      "İONA Ümraniye Güzellik Merkezi'nde cilt aydınlatma bakımı: ton eşitsizliği ve koyu görünüme yönelik aydınlatıcı bakım protokolü.",
  },
};
